import React from 'react';

export default function pieChart(props) {
    
    return (
        <svg
        {...props}
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.2099 14.89C19.5737 16.3945 18.5787 17.7202 17.3118 18.7513C16.0449 19.7824 14.5447 20.4874 12.9424 20.8048C11.34 21.1221 9.68434 21.0421 8.12006 20.5718C6.55578 20.1014 5.13054 19.2551 3.96893 18.1067C2.80733 16.9582 1.94473 15.5428 1.45655 13.9839C0.968371 12.4251 0.869476 10.7705 1.16851 9.16463C1.46755 7.55878 2.15541 6.05063 3.17196 4.77203C4.18851 3.49343 5.5028 2.48332 6.99992 1.83M20.9999 11C20.9999 9.68678 20.7413 8.38642 20.2387 7.17317C19.7362 5.95991 18.9996 4.85752 18.071 3.92893C17.1424 3.00035 16.04 2.26375 14.8267 1.7612C13.6135 1.25866 12.3131 1 10.9999 1V11H20.9999Z"
                stroke={props.color || "#667085"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
